
  export const style={
    inpuStyle:{
      colorInput:"#A843E0"
    },
    url:{
      urlClient:"https://grupopredigna.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_grupopredigna.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Predicoin/Predicoins"
    },
    teamName:{
      name:"Grupo Predigna"
    },
    hasToken: false,
    hostHeader: "grupopredigna"
  }
